// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__bVJi9","emptyBox":"image-placeholder_emptyBox__0Br0y"};